export function formatArr(arr, num) {
    let newArr = new Array(Math.ceil(arr.length / num));
    for (let i = 0; i < newArr.length; i++) {
        newArr[i] = [];
    }
    for (let i = 0; i < arr.length; i++) {
        newArr[Math.floor(i / num)][i % num] = arr[i];
    }
    return newArr;
}

export function timeStrToObj(timeStr) {
    let fObj = timeStr.split(' ');
    let dObj = fObj[0].split('-');
    let tObj = fObj[1].split(':');

    return new Date(dObj[0] - 0, dObj[1] - 1, dObj[2] - 0, tObj[0] - 0, tObj[1] - 0, tObj[2] - 0);
}

export function timeformat(timestamp, fmt = 'YYYY-MM-dd') {
    const dayTextArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    if (!timestamp) {
        return '未知';
    }
    var time;
    if (typeof timestamp == 'object' && timestamp.getDate) {
        time = timestamp;
    } else {
        time = new Date(timestamp);
    }
    var o = {
        'M+': time.getMonth() + 1, //月份
        'd+': time.getDate(), //日
        'h+': time.getHours(), //小时
        'm+': time.getMinutes(), //分
        's+': time.getSeconds(), //秒
        'q+': Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
    };
    if (/(Y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
    if (/(w+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, dayTextArr[time.getDay()]);
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
    return fmt;
}

export function getUrlParams(url) {
    var result = {};
    if (!url) return result;
    url.substr(url.indexOf('?') + 1)
        .split('&')
        .forEach(function(pairs_str) {
            var pairs = pairs_str.split('=');
            if (pairs[0]) {
                result[decodeURIComponent(pairs[0])] = decodeURIComponent(pairs[1] || '');
            }
        });

    return result;
}
export function setUrlParams(params, url) {
    let searchStr = '';
    for (let key in params) {
        searchStr = searchStr + key + '=' + params[key] + '&';
    }
    if (searchStr) {
        searchStr = searchStr.slice(0, -1);
        if (url.indexOf('?') > -1) {
            url = url + '&' + searchStr;
        } else {
            url = url + '?' + searchStr;
        }
    }

    return url;
}
export function toThousands(num) {
    const sign = num >= 0 ? '' : '-';
    num = Math.abs(num);
    num = (num || 0).toString();
    if (!num.includes('.')) {
        num += '.';
    }
    let result = num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
        return $1 + ',';
    });
    result = result.replace(/\.$/, '');

    return sign + result;
}
export function cutLetter(str, len, fmt = '...') {
    if (str && str.length > len) {
        str = str.slice(0, len) + fmt;
    }

    return str;
}
